<template>
  <el-dialog
    :append-to-body="true"
    title="选择类目弹窗"
    :visible.sync="categoryVisible"
    width="800px"
    :before-close="categoryCancellHandle"
    :close-on-click-modal="false"
  >
    <!-- <div class="contents" id="searchInput">
      <div class="flex" :class="{ isActive: isShowResult }">
        <el-input
          class="middle_input"
          size="middle"
          v-model.trim="searchValue"
          placeholder="请输入最小分类名称"
          @keyup.enter="goToSearch()"
        ></el-input>
        <p @click="goToSearch" class="middle_btn">查找</p>
        <p @click="restSearch" class="rest_btn">重置</p>
        <div class="search-result" v-show="isShowResult" v-loading="loading">
          <ul v-if="categoryList.length > 0">
            <li @click="selectItem(item)" v-for="item in categoryList" :key="item.categoryId">
              <span v-for="(subitem, index) in item.routeList" :key="subitem.categoryId">
                <i v-html="subitem.categoryNameLight"></i>
                <i v-if="index < item.routeList.length - 1">></i>
              </span>
            </li>
          </ul>
          <div v-else class="no-result">
            <p class="p-1">抱歉，没找到相关结果</p>
            <p class="p-2">换个搜索词试一试</p>
          </div>
        </div>
      </div>
    </div> -->

    <div class="category">
      <div class="item-box">
        <div class="item-input-wrap">
          <el-input
            v-model="input1"
            placeholder="请输入内容"
            class="item-input"
            @input="searchCategory"
            @focus="searchLevel(1)"
          ></el-input>
        </div>
        <ul>
          <!-- <li
            class="item-name e-pointer"
            v-for="item in fristCategry"
            :class="{ active: isForActive1 == item.categoryId }"
            :key="item.categoryId"
            @click="
              showNext(item.categoryId, 2, item.isLeaf, item.categoryName, item.children, item)
            "
          >
            <span>{{ item.categoryName }}</span>
            <i class="el-icon-arrow-right"></i>
          </li> -->
          <li
            v-for="item in fristCategry"
            :key="item.categoryId"
            class="item-name e-pointer"
            :class="{ active: isForActive1 == item.categoryId }"
          >
            <el-tooltip
              class="item"
              effect="light"
              :disabled="item.applyFlag == 1 ? false : true"
              :content="item.forbidResaon"
              placement="top-end"
            >
              <el-link
                :disabled="item.applyFlag == 1 ? true : false"
                :underline="false"
                @click="
                  showNext(
                    item.categoryId,
                    2,
                    item.isLeaf,
                    item.categoryName,
                    item.children,
                    item
                  )
                "
              >
                <span>{{ item.categoryName }}</span>
                <i v-if="!item.leafFlag" class="el-icon-arrow-right"></i>
              </el-link>
            </el-tooltip>
          </li>
        </ul>
      </div>
      <div v-show="level > 1" class="item-box">
        <div class="item-input-wrap">
          <el-input
            v-model="input2"
            placeholder="请输入内容"
            class="item-input"
            @input="searchCategory"
            @focus="searchLevel(2)"
          >
          </el-input>
        </div>
        <ul>
          <li
            v-for="item in secCategry"
            :key="item.categoryId"
            class="item-name e-pointer"
            :class="{ active: isForActive2 == item.categoryId }"
          >
            <el-tooltip
              class="item"
              effect="light"
              :disabled="item.applyFlag == 1 ? false : true"
              :content="item.forbidResaon"
              placement="top-end"
            >
              <el-link
                :disabled="item.applyFlag == 1 ? true : false"
                :underline="false"
                @click="
                  showNext(
                    item.categoryId,
                    3,
                    item.isLeaf,
                    item.categoryName,
                    item.children,
                    item
                  )
                "
              >
                <span>{{ item.categoryName }}</span>
                <i v-if="!item.leafFlag" class="el-icon-arrow-right"></i>
              </el-link>
            </el-tooltip>
          </li>
        </ul>
      </div>
      <div v-show="level > 2" class="item-box">
        <div class="item-input-wrap">
          <el-input
            v-model="input3"
            placeholder="请输入内容"
            class="item-input"
            @input="searchCategory"
            @focus="searchLevel(3)"
          >
            <!-- <img class="icon-search"  v-if="isActiveLevel==1"   slot="suffix" src="../../../../../assets/img/product/icon-search-active.png" alt="" > -->
            <!-- <img class="icon-search" slot="suffix" :src="imgList.searchDefault" alt="" /> -->
          </el-input>
        </div>
        <ul>
          <!-- <li
            class="item-name e-pointer"
            v-for="item in thirdCategry"
            :class="{ active: isForActive3 == item.categoryId }"
            :key="item.categoryId"
            @click="
              showNext(item.categoryId, 4, item.isLeaf, item.categoryName, item.children, item)
            "
          >
            <span>{{ item.categoryName }}</span>
            <i v-if="salesScope == 2 && !item.isLeaf" class="el-icon-arrow-right"></i>
            <i
              v-if="salesScope == 1 && item.children && item.children.length > 0"
              class="el-icon-arrow-right"
            ></i>
          </li> -->
          <li
            v-for="item in thirdCategry"
            :key="item.categoryId"
            class="item-name e-pointer"
            :class="{ active: isForActive2 == item.categoryId }"
          >
            <el-tooltip
              class="item"
              effect="light"
              :disabled="item.applyFlag == 1 ? false : true"
              :content="item.forbidResaon"
              placement="top-end"
            >
              <el-link
                :disabled="item.applyFlag == 1 ? true : false"
                :underline="false"
                @click="
                  showNext(
                    item.categoryId,
                    4,
                    item.isLeaf,
                    item.categoryName,
                    item.children,
                    item
                  )
                "
              >
                <span>{{ item.categoryName }}</span>
                <i v-if="!item.leafFlag" class="el-icon-arrow-right"></i>
              </el-link>
            </el-tooltip>
          </li>
        </ul>
      </div>
      <div v-show="level > 3" class="item-box">
        <div class="item-input-wrap">
          <el-input
            v-model="input4"
            placeholder="请输入内容"
            class="item-input"
            @input="searchCategory"
            @focus="searchLevel(4)"
          >
            <!-- <img class="icon-search"  v-if="isActiveLevel==1"   slot="suffix" src="../../../../../assets/img/product/icon-search-active.png" alt=""  > -->
            <!-- <img class="icon-search" slot="suffix" :src="imgList.searchDefault" alt="" /> -->
          </el-input>
        </div>
        <ul>
          <!-- <li
            class="item-name e-pointer"
            :class="{ active: isForActive4 == item.categoryId }"
            v-for="item in forCategry"
            :key="item.categoryId"
            @click="
              showNext(item.categoryId, 5, item.isLeaf, item.categoryName, item.children, item)
            "
          >
            <span>{{ item.categoryName }}</span>
            <i class="el-icon-arrow-right"></i>
          </li> -->
          <li
            v-for="item in forCategry"
            :key="item.categoryId"
            class="item-name e-pointer"
            :class="{ active: isForActive2 == item.categoryId }"
          >
            <el-tooltip
              class="item"
              effect="light"
              :disabled="item.applyFlag == 1 ? false : true"
              :content="item.forbidResaon"
              placement="top-end"
            >
              <el-link
                :disabled="item.applyFlag == 1 ? true : false"
                :underline="false"
                @click="
                  showNext(
                    item.categoryId,
                    5,
                    item.isLeaf,
                    item.categoryName,
                    item.children,
                    item
                  )
                "
              >
                <span>{{ item.categoryName }}</span>
                <i v-if="!item.leafFlag" class="el-icon-arrow-right"></i>
              </el-link>
            </el-tooltip>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div slot="footer">
      <div class="submit-btn btn" @click="sendMessage">确定</div>
    </div> -->
  </el-dialog>
</template>

<script>
import api from '../../api/organization/index';

console.log();
export default {
  props: {
    categoryVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      paramsObj: {},
      active: 0,
      input1: '',
      input2: '',
      input3: '',
      input4: '',
      fristCategry: [],
      secCategry: [],
      thirdCategry: [],
      forCategry: [],
      isForActive1: null,
      isForActive2: null,
      isForActive3: null,
      isForActive4: null,
      level: 1, //
      isLeaf: 0, // 0-否1-是
      selectCategrayName: '',
      level1name: '',
      level2name: '',
      level3name: '',
      level4name: '',
      isActiveLevel: 0,
      salesScope: 1, // 销售范围
      allCategoryList: [], //
      isShowResult: false,
      searchValue: '',
      categoryList: [],
      categoryListInHighLigth: [],
      loading: false,
      allCategoryAggrementList: true, // 协议list
      /* imgList: {
        platformChoice: require("../../../../../assets/img/product/icon-platform-choice.png"),
        platformDefault: require("../../../../../assets/img/product/icon-platform-default.png"),
        agreementChoice: require("../../../../../assets/img/product/icon-agreement-choice.png"),
        agreementDefault: require("../../../../../assets/img/product/icon-agreement-default.png"),
        searchDefault: require("../../../../../assets/img/product/icon-search-default.png"),
      }, */
    };
  },
  watch: {
    categoryVisible(oldVal) {
      if (oldVal) {
        this.level = 1;
        this.queryApplyCategoryTree();
      }
    },
  },
  methods: {
    closeSearch(event) {
      const currentCli = document.getElementById('searchInput');
      if (currentCli) {
        if (!currentCli.contains(event.target)) {
          // 点击到了id为sellineName以外的区域，隐藏下拉框
          this.isShowResult = false;
        }
      }
      // this.isShowResult = false;
    },
    goToSearch() {
      /* if (utils.deleteSpace(this.searchValue) == "") {
        this.$message.warning("请输入搜索内容");
        return;
      } */
      this.isShowResult = true;
      this.getCategroyRouteList(this.searchValue);
      this.loading = true;
    },
    restSearch() {
      this.searchValue = null;
      this.isShowResult = false;
      this.handleRestCategoryList();
    },
    selectItem(item) {
      this.isShowResult = false;
      //  this.$emit('selectCategoryItem',item);
      this.handleSelectCategory(item);
    },
    async getCategroyRouteList(name) {
      const res = await api.selectCategoryRouteList({ categoryName: name });
      if (parseInt(res.code) === 200) {
        this.categoryList = res.data;
        this.addTxtHighLight(this.categoryList, this.searchValue);
        this.loading = false;
        console.log(this.categoryList);
      }
    },
    // 添加高亮
    addTxtHighLight(arr, key) {
      arr.map((item) => {
        const index = item.routeList.length - 1;
        item.routeList.map((subitem, subIndex) => {
          if (subIndex == index) {
            const replaceReg = new RegExp(key, 'g');
            // 高亮替换v-html值
            const replaceString = `<span class="search-text" style="color:#2587FF">${key}</span>`;
            // 开始替换
            subitem.categoryNameLight = subitem.categoryName.replace(
              replaceReg,
              replaceString
            );
          } else {
            subitem.categoryNameLight = subitem.categoryName;
          }

          // subitem.categoryName = subitem.categoryName.replace(replaceReg, replaceString);
        });
      });
      console.log(arr);
    },
    // 获取搜索列表
    async getCategoryList(id, level) {
      const params = { categoryId: id };
      const res = await api.getCategoryByParentId(params);
      console.log(res);
      if (res.code == 200) {
        if (level == 1) {
          this.fristCategry = res.data;
          console.log(this.fristCategry, 'this.fristCategry');
        }
        if (level == 2) {
          this.secCategry = res.data;
        }
        if (level == 3) {
          this.thirdCategry = res.data;
        }
        if (level == 4) {
          this.forCategry = res.data;
        }
      } else {
        this.$message.error(res.message);
      }
    },
    // 获取有商品下的类目全树
    async queryApplyCategoryTree() {
      const res = await api.queryApplyCategoryTree();
      console.log(res);
      this.level = 1;
      this.allCategoryList = res?.data;
      this.fristCategry = this.allCategoryList;
      this.secCategry = [];
      this.thirdCategry = [];
      this.forCategry = [];
    },
    // 获取协议客户
    async usefulCategoryTree() {
      const res = await api.queryApplyCategoryTree();
      console.log(res);
      this.level = 1;
      this.allCategoryList = res?.data;
      this.fristCategry = this.allCategoryList;
      this.secCategry = [];
      this.thirdCategry = [];
      this.forCategry = [];
    },
    showNext(id, level, leaf, name, children = [], item) {
      console.log(id, level, leaf, name, children);
      // if (this.salesScope == 2) {
      //   if (leaf !== 1) {
      //     this.level = level;
      //   }
      // }
      if (level < 5 && children.length > 0) {
        this.level = level;
      }

      if (level == 2) {
        this.level1name = name;
        this.thirdCategry = [];
        this.forCategry = [];
        this.isForActive1 = id;
      }
      if (level == 3) {
        this.level2name = name;
        this.forCategry = [];
        this.isForActive2 = id;
      }
      if (level == 4) {
        this.level3name = name;
        this.isForActive3 = id;
      }
      if (level == 5) {
        this.level4name = name;
        this.isForActive4 = id;
      }
      // this.$store.commit('addProductList' , { id, name });
      // this.addProductList({ id, name });
      this.isLeaf = leaf;
      console.log(this.$store.state);
      // if (this.salesScope == 2) {
      //   this.getCategoryList(id, level);
      // } else {
      if (level == 2) {
        this.fristCategry.map((item) => {
          if (item.categoryId == id) {
            this.secCategry = item.children;
          }
        });
      }
      if (level == 3) {
        this.secCategry.map((item) => {
          if (item.categoryId == id) {
            this.thirdCategry = item.children;
          }
        });
      }
      if (level == 4) {
        this.thirdCategry.map((item) => {
          if (item.categoryId == id) {
            this.forCategry = item.children;
          }
        });
        if (this.forCategry?.length == 0) {
          this.isLeaf = 1;
        }
      }
      if (level == 5) {
        this.isLeaf = 1;
        this.thirdCategry.map((item) => {
          if (item.categoryId == id) {
            this.forCategry = item.children;
          }
        });
      }
      // this.paramsObj = { ...item };
      if (item.leafFlag && leaf == 0) {
        return this.$message.warning('末级分类不是小类');
      }
      this.$emit('getCategoryInfo', item, level);
      this.isLeaf = leaf;
    },

    async searchCategory(val) {
      console.log(this.level);
      if (val == '') {
        if (this.isActiveLevel == 1) {
          await this.queryApplyCategoryTree();
        }
        if (this.isActiveLevel == 2) {
          // if (this.salesScope == 2) {
          //   await this.getCategoryList(this.isForActive1, this.isActiveLevel);
          // } else {
          if (this.level == 2) {
            this.fristCategry.map((item) => {
              if (item.categoryId == this.isForActive1) {
                this.secCategry = item.children;
              }
            });
            // }
          }
        }
        if (this.isActiveLevel == 3) {
          // if (this.salesScope == 2) {
          //   await this.getCategoryList(this.isForActive2, this.isActiveLevel);
          // } else {
          if (this.level == 3) {
            this.secCategry.map((item) => {
              if (item.categoryId == this.isForActive2) {
                this.thirdCategry = item.children;
              }
            });
            // }
          }
        }
        if (this.isActiveLevel == 4) {
          // if (this.salesScope == 2) {
          //   await this.getCategoryList(this.isForActive3, this.isActiveLevel);
          // } else {
          if (this.level == 4) {
            this.thirdCategry.map((item) => {
              if (item.categoryId == this.isForActive3) {
                this.forCategry = item.children;
              }
            });
            // }
          }
        }
      }
      if (this.isActiveLevel == 1) {
        const res = this.fristCategry.filter(
          (item) => item.categoryName.indexOf(val) != -1
        );
        this.fristCategry = res;
      }
      if (this.isActiveLevel == 2) {
        const res = this.secCategry.filter(
          (item) => item.categoryName.indexOf(val) != -1
        );
        this.secCategry = res;
      }
      if (this.isActiveLevel == 3) {
        const res = this.thirdCategry.filter(
          (item) => item.categoryName.indexOf(val) != -1
        );
        this.thirdCategry = res;
      }
      if (this.isActiveLevel == 4) {
        const res = this.forCategry.filter(
          (item) => item.categoryName.indexOf(val) != -1
        );
        this.forCategry = res;
      }
    },
    // 展示搜索框选中的分类
    handleSelectCategory(options) {
      console.log(options);
      this.level = options.routeList.length;
      this.fristCategry = options.routeList[0] ? [options.routeList[0]] : [];
      this.secCategry = options.routeList[1] ? [options.routeList[1]] : [];
      this.thirdCategry = options.routeList[2] ? [options.routeList[2]] : [];
      this.forCategry = options.routeList[3] ? [options.routeList[3]] : [];
      this.isForActive1 = options.routeList[0]
        ? options.routeList[0].categoryId
        : null;
      this.isForActive2 = options.routeList[1]
        ? options.routeList[1].categoryId
        : null;
      this.isForActive3 = options.routeList[2]
        ? options.routeList[2].categoryId
        : null;
      this.isForActive4 = options.routeList[3]
        ? options.routeList[3].categoryId
        : null;
      this.level1name = options.routeList[0]
        ? options.routeList[0].categoryName
        : null;
      this.level2name = options.routeList[1]
        ? options.routeList[1].categoryName
        : null;
      this.level3name = options.routeList[2]
        ? options.routeList[2].categoryName
        : null;
      this.level4name = options.routeList[3]
        ? options.routeList[3].categoryName
        : null;
      this.isLeaf = options.routeList[this.level - 1].isLeaf;
    },
    // 重置搜索列表
    handleRestCategoryList() {
      this.secCategry = [];
      this.thirdCategry = [];
      this.forCategry = [];
      this.level = 1;
      this.salesScope = 1;
      this.queryApplyCategoryTree();
    },

    // --------分割线----------

    sendMessage() {
      if (this.isLeaf != 1) {
        this.$message.warning('请选择末级菜单');
        return;
      }
      this.$emit('getCategoryInfo', this.paramsObj);
      this.$emit('update:categoryVisible', false);
    },

    // 类目弹窗取消
    categoryCancellHandle() {
      // this.categoryVisible = false;
      // 清空搜索内容
      this.input1 = '';
      this.input2 = '';
      this.input3 = '';
      this.input4 = '';
      // 清空数据
      this.fristCategry = [];
      this.secCategry = [];
      this.thirdCategry = [];
      this.forCategry = [];
      this.level = 1;
      this.isForActive1 = null;
      this.isForActive2 = null;
      this.isForActive3 = null;
      this.isForActive4 = null;
      this.$emit('update:categoryVisible', false);
    },

    searchLevel(val) {
      this.level = val;
      this.isActiveLevel = val;
    },
  },
};
</script>
<style lang="scss" scoped>
$main-col: #2587ff;
.category {
  display: flex;
  // justify-content: space-between;
  .item-box {
    padding: 10px;
    width: 23%;
    border: 1px solid #ddd;
    margin-right: 20px;
    .item-input-wrap {
      ::v-deep .el-input__inner {
        border-radius: 0;
        height: 36px;
      }
      ::v-deep .el-input__icon {
        line-height: 36px;
      }
    }
    ul {
      height: 360px;
      overflow: auto;
    }
    .item-input {
      margin-bottom: 10px;
    }
    .item-name {
      display: flex;
      justify-content: space-between;
      padding: 3px 0;
      &.active {
        background: #f4f7ff;
        color: #0064c8;
      }
    }
  }
}
.contents {
  margin: 20px 0;
  .search-result {
    position: absolute;
    background: #fff;
    z-index: 1000;
    top: 40px;
    width: 420px;
    border-left: 1px solid $main-col;
    border-right: 1px solid $main-col;
    border-bottom: 1px solid $main-col;
    ul {
      overflow-y: auto;
      height: 280px;
    }
    li {
      padding: 18px;
      font-size: 14px;
      line-height: 1;
      &:hover {
        cursor: pointer;
        background: #f4f7ff;
      }
    }
  }
  .flex {
    display: flex;
    position: relative;
  }
  .middle_input {
    width: 330px;
  }
  .middle_btn {
    width: 90px;
    height: 40px;
    line-height: 40px;
    color: #fff;
    background: $main-col;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
  }
  .rest_btn {
    width: 90px;
    height: 40px;
    line-height: 40px;
    color: #333333;
    background: #fff;
    text-align: center;
    cursor: pointer;
    border: 1px solid #c5c5c5;
    margin-left: 20px;
    font-size: 14px;
  }
}
.no-result {
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  img {
    width: 100px;
  }
  .p-1 {
    font-size: 16px;
    color: #333;
    margin: 10px 0;
  }
  .p-2 {
    font-size: 14px;
    color: #666;
  }
}
::v-deep .el-dialog__header {
  background: #f5f5f5;
  height: 40px;
  padding: 0 20px;
  line-height: 40px;
  .el-dialog__headerbtn {
    top: 8px;
  }
  .el-dialog__title {
    font-size: 14px;
  }
}

::v-deep .el-dialog__footer {
  display: flex;
  justify-content: center;
  .btn {
    width: 80px;
    text-align: center;
    height: 30px;
    line-height: 27px;
    cursor: pointer;
  }

  .submit-btn {
    background: #2587ff;
    border: 1px solid #2587ff;
    color: #ffffff;
    &:hover,
    :active {
      background-color: #126edf;
    }
  }
}

::v-deep .el-dialog__body {
  padding: 10px;
}
</style>
